// extracted by mini-css-extract-plugin
module.exports = {"containerTotals":"styles_containerTotals__2w9Mt"};